/**
 * The ids of board drafts. A stored board's id is a short prefix, an underscore
 * and a random part, made by the platform, so no stored board's id starts
 * with this prefix and an id alone says where its board is kept.
 */
const BOARD_DRAFT_ID_PREFIX = "draft-";

export function newBoardDraftId(): string {
  return `${BOARD_DRAFT_ID_PREFIX}${crypto.randomUUID()}`;
}

export function isBoardDraftId(boardId: string): boolean {
  return boardId.startsWith(BOARD_DRAFT_ID_PREFIX);
}
